$primary-green: #81ba43;
$secondary-green: #7fb02f;

.btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 0.5rem 0.8rem;
	border-radius: 0.5rem;
	font-weight: 600;
	font-size: 0.92rem;
	cursor: pointer;
	border: 1px solid transparent;
	transition:
		background-color 0.15s ease,
		color 0.15s ease,
		border-color 0.15s ease,
		filter 0.15s ease,
		opacity 0.15s ease;
	text-decoration: none;
}
.btn:focus-visible {
	outline: 0;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.label {
	line-height: 1;
}
.icon {
	display: grid;
	place-items: center;
	width: 18px;
	height: 18px;
}

.sm {
	padding: 0.4rem 0.7rem;
	font-size: 0.88rem;
}
.md {
	padding: 0.5rem 0.8rem;
	font-size: 0.92rem;
}
.lg {
	padding: 0.6rem 1rem;
	font-size: 1rem;
}

.block {
	width: 100%;
}

.primary {
	background: $secondary-green;
	color: #fff;
}
.primary:hover {
	filter: brightness(0.96);
}
.primary:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.primary_outline {
	background: transparent;
	color: $secondary-green;
	border-color: $secondary-green;
}
.primary_outline:hover {
	background: $secondary-green;
	color: #fff;
}

.secondary {
	background: #fff;
	color: #111827;
	border-color: #e5e7eb;
}
.secondary:hover {
	background: #f3f4f6;
}
.secondary:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.secondary_outline {
	background: transparent;
	color: #111827;
	border-color: #e5e7eb;
}
.secondary_outline:hover {
	background: #f3f4f6;
}

.ghost {
	background: #fff;
	color: #374151;
	border-color: #e5e7eb;
}
.ghost:hover {
	background: #f9fafb;
}
.ghost:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.neutral {
	background: #6b7280;
	color: #fff;
	border-color: #6b7280;
}
.neutral:hover {
	background: #4b5563;
}
.neutral:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.danger {
	background: #d7373f;
	color: #fff;
	border-color: #d7373f;
}
.danger:hover {
	background: #b32a2f;
}
.danger:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.warning {
	background: #d77200;
	color: #fff;
	border-color: #d77200;
}
.warning:hover {
	background: #b35f00;
}
.warning:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.success {
	background: #7fb02f;
	color: #fff;
	border-color: #7fb02f;
}
.success:hover {
	background: #6a9525;
}
.success:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.info {
	background: #3b82f6;
	color: #fff;
	border-color: #3b82f6;
}
.info:hover {
	background: #2563eb;
}
.info:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.info_outline {
	background: transparent;
	color: #3b82f6;
	border-color: #3b82f6;
}
.info_outline:hover {
	background: #3b82f6;
	color: #fff;
}

.loading {
	pointer-events: none;
}
.spinner {
	width: 16px;
	height: 16px;
	border-radius: 9999px;
	border: 2px solid transparent;
	border-top-color: currentColor;
	border-right-color: currentColor;
	animation: spin 0.8s linear infinite;
}
@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
